import {Attributes} from '@components/modal/proparties_modal';

const Properties_item = ({item}: {item?: Attributes}) => {
  return (
    <div className="p-1">
      <div className="rounded-lg mx-auto p-[1px] bg-green-gradation w-full">
        <button className="dark:bg-black-green bg-green-light rounded-lg px-2.5 py-4 text-sm dark:text-white w-full">
          <span className="font-medium flex items-center justify-center text-sm  text-transparent bg-clip-text bg-green-gradation mb-3">
            {item?.trait_type}
          </span>
          <span className="text-[14px] dark:text-light-grey text-dark-grey font-medium">
            {item?.value}
          </span>
        </button>
      </div>
    </div>
  );
};

export default Properties_item;
